import { forwardRef, type ForwardedRef } from 'react';

interface FooterProps {
  left?: React.ReactNode;
  middle: React.ReactNode;
  right: React.ReactNode;
}

const Footer = forwardRef(
  ({ left, middle, right }: FooterProps, ref: ForwardedRef<HTMLDivElement>) => (
    <div
      className='z-50 flex w-full flex-col items-center gap-2 bg-white px-4 py-2.5 shadow-sm select-none sm:flex-row'
      ref={ref}
    >
      <div className='flex basis-5/12'>{left}</div>
      <div className='flex basis-2/12 justify-center'>{middle}</div>
      <div className='flex basis-5/12 justify-end'>{right}</div>
    </div>
  ),
);

Footer.displayName = 'Footer';

export default Footer;
